import { ConversationNodeInstruction, InstructionType } from 'packages/bot/entities/ConversationNodeInstruction';
import { EntityBuilder } from '@decahedron/entity';
import ENV from 'config/env.js';
import { Observable, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { types } from '../../store/public/bot/mutations';
export var Action;
(function (Action) {
    Action[Action["UNKNOWN"] = 0] = "UNKNOWN";
    Action[Action["SEND_TO_RENDER"] = 1] = "SEND_TO_RENDER";
    Action[Action["START_TYPING"] = 2] = "START_TYPING";
    Action[Action["STOP_TYPING"] = 3] = "STOP_TYPING";
})(Action || (Action = {}));
var PublicBotHelper = /** @class */ (function () {
    function PublicBotHelper(store) {
        var _this = this;
        this.store = store;
        this.conversationStarted = false;
        this.messageTypingTracker = new Observable(function (s) { return _this.channel = s; }).pipe(concatMap(function (action) { return of(action).pipe(delay(_this.calculateDelay(action))); }));
        this.messageTypingTracker.subscribe(function (_a) {
            var action = _a.action, instruction = _a.instruction;
            switch (action) {
                case Action.START_TYPING:
                    _this.store.commit('publicBot/setTyping', instruction.id);
                    break;
                case Action.SEND_TO_RENDER:
                    _this.store.commit("publicBot/" + types.MOVE_INSTRUCTION);
                    break;
                case Action.STOP_TYPING:
                    _this.store.commit('publicBot/setTyping', null);
                    break;
                default:
                    return null;
            }
        });
    }
    PublicBotHelper.prototype.establishConnection = function (conversationId) {
        var _this = this;
        this.socket = new WebSocket(ENV.BOT_WEBSOCKET_API + "conversations/" + conversationId);
        this.socket.onmessage = function (event) {
            var i = EntityBuilder.buildOne(ConversationNodeInstruction, JSON.parse(event.data));
            _this.store.commit('publicBot/pushInstruction', i);
            _this.channel.next({ instruction: i, action: Action.START_TYPING });
            _this.channel.next({ instruction: i, action: Action.SEND_TO_RENDER });
            _this.channel.next({ instruction: i, action: Action.STOP_TYPING });
        };
    };
    PublicBotHelper.prototype.sendResponse = function (data) {
        this.store.commit('publicBot/setValueOnLatestInstruction', data.value);
        this.socket.send(JSON.stringify(data));
    };
    PublicBotHelper.prototype.calculateDelay = function (_a) {
        var _b, _c;
        var action = _a.action, instruction = _a.instruction;
        // we only want to add the delay to stop typing
        if (action !== Action.STOP_TYPING) {
            return 0;
        }
        if (!this.conversationStarted) {
            this.conversationStarted = true;
            return 0;
        }
        var messageBaseTimeout = 500;
        var timeoutPerLetter = 50;
        var collectInstructionTimeout = 400;
        var timeout = instruction.type === InstructionType.SEND_MESSAGE ?
            messageBaseTimeout + (((_c = (_b = instruction.data) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.length) * timeoutPerLetter) :
            collectInstructionTimeout;
        return Math.min(3000, timeout);
    };
    return PublicBotHelper;
}());
export { PublicBotHelper };
